// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1lBHo","insightsList":"newBusinessInsightsMenu_insightsList__Fn5wz","active":"newBusinessInsightsMenu_active__1p59D"};